export default "__VITE_ASSET___yipX9jF__"